<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :span="16">
            <a-form-item label="字典名称">
              <j-input placeholder="请输入字典名称" v-model="queryParam.dictName"></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="8">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search"></a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"></a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px"></a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"

        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="checked" slot-scope="text, record">
            <a-radio :checked="record.id===currentRecord.id"></a-radio>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
                          <a @click="handleSelect(record)">字典</a>
               <a-divider type="vertical" />
       <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDeleteMy(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <projectDict-modal ref="modalForm" @ok="modalFormOk" :projectId="projectId"></projectDict-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectDictModal from './modules/ProjectDictModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: "ProjectDictList",
    mixins:[JeecgListMixin],
    components: {
      JInput,
      ProjectDictModal
    },
    data () {
      return {
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        baseQueryParam:{projectId:Vue.ls.get(CACHE_PROJECT_ID) ||''},
        description: '项目字典管理页面',
        // 表头
        columns: [
          {
            title: '#',
            align:"center",
            ellipsis: true,
            dataIndex: '',
            width: 50,
            scopedSlots: { customRender: 'checked' },
          },
          {
            title: '字典名称',
            ellipsis: true,
            align:"center",
            dataIndex: 'dictName'
          },
          {
            title: '类型',
            align:"center",
            dataIndex: 'type_dictText'
          },
          {
            title: '描述',
            ellipsis: true,
            align:"center",
            dataIndex: 'description'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/project/projectDict/list",
          delete: "/project/projectDict/delete",
        },
        currentRecord:{},
      }
    },
    mounted(){
    },
    computed: {
    },
    methods: {
      handleSelect(record){
        this.currentRecord = record
        this.$emit('onSelect',record)
      },
      handleDeleteMy(id){
        this.handleDelete(id)
        this.handleSelect({})
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>